var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 54,
    viewBox: "0 0 56 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 493"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 1232",
    cx: 24.5,
    cy: 24.5,
    r: 22.5,
    stroke: "#D9D9D9",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 1233",
    cx: 42,
    cy: 40,
    r: 12,
    stroke: "#D9D9D9",
    strokeWidth: 4
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoWhite);
export default __webpack_public_path__ + "static/media/logoWhite.b54460506e7259ba5d1fdf3f3117db38.svg";
export { ForwardRef as ReactComponent };